import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import {getValueArray} from '../../../common/utils/array';

import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

import FirstIcon from '@material-ui/icons/FirstPage';
import LastIcon from '@material-ui/icons/LastPage';
import PrevIcon from '@material-ui/icons/ChevronLeft';
import NextIcon from '@material-ui/icons/ChevronRight';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

import AlertDialog from '../../../common/components/dialog/alert-dialog';
import ViewerInner from './viewer-inner';


const styles = theme => ({
    contentsTitleWrap:{
        position:'relative'
    },
    contentTitle:{
        color:'#FFFFFF'
    },
    contentSupportText:{
        position:'absolute',
        right:0,
        top:0,
        color:"#FFFFFF",
        cursor:"pointer",

    },
    contentSupportTextIcon:{
        verticalAlign:'top',
        marginRight: 5
    },
    button: {
        margin: theme.spacing.unit,
        display:'inline-block',
        color:"#FFFFFF"
    },
    buttonWrap:{
        textAlign:'center',
        position:'relative'
    },
    pageNumbers:{
        position:'absolute',
        left:0,
        top:20,
        color:'#FFFFFF',
        fontFamily:"Roboto, Helvetica, Arial, sans-serif"
    },
    pageZooms:{
        position:'absolute',
        right:-8,
        top:0
    },
    closeIcon:{
        position:'absolute',
        top:10,
        right:10
    },
    printIcon:{
        position:'absolute',
        bottom:30,
        right:30
    },
    documentWrapper:{
        backgroundColor:'rgb(40,40,40)'
    },
    pages:{
        marginLeft:'auto',
        marginRight:'auto'
    },


});

function PaperComponent(props) {
    return (
        <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper children={props.children} className={props.className + " dialog_paper_override"} elevation={props.elevation} />
        </Draggable>
    );
}

class Viewer extends Component {



    constructor(props) {
        super(props);
        this.state = {
            pageNumber:1,
            numPages:props.dataSource.length,
            closeDialogOpen : false,
            saveDialogOpen : false,
            source:props.dataSource,
            imageOpen : false,
        };

    }

    handleClickFirst = () =>{
        this.setState({
            pageNumber:1
        })
    };

    handleClickPrev = () =>{
        let pageNumber = this.state.pageNumber;
        if(pageNumber !== 1){
            this.setState({
                pageNumber:pageNumber -1
            })
        }

    };

    handleClickNext = () =>{
        const numPages = this.state.numPages;
        let pageNumber = this.state.pageNumber;
        if(pageNumber !== numPages){
            this.setState({
                pageNumber:pageNumber +1
            })
        }
    };

    handleClickLast = () =>{
        const numPages = this.state.numPages;
        this.setState({
            pageNumber:numPages
        })
    };

    handleUpdateValue = (key,value,errors)=>{
        let source = getValueArray(this.state.source);
        let row = source[this.state.pageNumber-1];
        row[key] = value;
        let is_error = false;
        Object.keys(errors).forEach(key=> {
            if(errors[key]){
                is_error = true;
            }
        });

        row["IsComplete"] = (
            row["IsDelete"] ||
            (
                !is_error &&
                (row["SlipNO"] !== "") &&
                (row["SlipDate"] !== "") &&
                (row["SlipPage"] !== "") &&
                (row["ShipperCD"] !== "")
            )
        );
        this.setState({
            source
        })
    };


    handleClickSave = () =>{
        this.setState({
            saveDialogOpen:true
        });
    };

    handleCancelSave = () =>{
        this.setState({
            saveDialogOpen:false
        });
    };

    handleSave = () =>{
        this.setState({
            saveDialogOpen:false
        });
        if(this.props.afterSaveFunc) this.props.afterSaveFunc(this.state.source);

    };

    handleClickClose = () =>{
        this.setState({
            closeDialogOpen:true
        });
    };

    handleCancelClose = () =>{
        this.setState({
            closeDialogOpen:false
        });
    };

    handleClose = () => {
        this.setState({
            closeDialogOpen:false
        });
        if(this.props.afterCloseFunc) this.props.afterCloseFunc();
    };

    handleClickImageOpen = () => {
        this.setState({
            imageOpen:true
        });
    };

    handleImageClose = () => {
        this.setState({
            imageOpen:false
        });
    };



    render() {
        const {pageNumber,numPages,source,imageOpen} = this.state;
        const {classes} = this.props;
        const targetRow = source[pageNumber-1];
        const isComplete = source.filter(row => row.IsComplete === true).length === numPages;

        return (

            <div className="over_rays">
                <div className={classes.closeIcon}>
                    <IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
                                onClick={this.handleClickClose}>
                        <CloseIcon/>
                    </IconButton>
                </div>
                {targetRow &&
                <div className={"pdf_viewer_frames"}>
                    <div className={classes.contentsTitleWrap}>
                        <p className={classes.contentTitle}>
                            QRコードが読み込めないPDFページに必要情報を入力してください
                        </p>
                        <p className={classes.contentSupportText} onClick={this.handleClickImageOpen}>
                            <i className={classNames("material-icons",classes.contentSupportTextIcon)}>
                                help_outline
                            </i>必要情報の見方
                        </p>
                    </div>

                    <ViewerInner
                        filePath={targetRow.temp_file_url}
                        orgFileName={targetRow.original_file_name}
                        pageNumber={targetRow.page_number}
                        SlipDate={targetRow.SlipDate}
                        ShipperCD={targetRow.ShipperCD}
                        SlipNO={targetRow.SlipNO}
                        SlipPage={targetRow.SlipPage}
                        IsDelete={targetRow.IsDelete}
                        changeDataFunc={this.handleUpdateValue}
                    />
                    <div className={classes.buttonWrap}>
                        <div className={classes.pageNumbers}>
                            {pageNumber} / {numPages}
                        </div>
                        <IconButton className={classes.button} aria-label="First" onClick={this.handleClickFirst}>
                            <FirstIcon/>
                        </IconButton>
                        <IconButton className={classes.button} aria-label="Prev" onClick={this.handleClickPrev}>
                            <PrevIcon/>
                        </IconButton>
                        <IconButton className={classes.button} aria-label="Next" onClick={this.handleClickNext}>
                            <NextIcon/>
                        </IconButton>
                        <IconButton className={classes.button} aria-label="Last" onClick={this.handleClickLast}>
                            <LastIcon/>
                        </IconButton>
                    </div>
                </div>
                }
                <div className={classes.printIcon}>
                    <Fab color="primary" aria-label="Add" className={classes.fab} onClick={this.handleClickSave} disabled={!isComplete}>
                        <SaveIcon/>
                    </Fab>
                </div>
                <AlertDialog
                    open={this.state.closeDialogOpen}
                    title={"ご注意ください"}
                    text={<span>現在アップロード処理中のファイルはすべて破棄されます</span>}
                    okFunction={this.handleClose}
                    closeFunction={this.handleCancelClose}
                />
                <AlertDialog
                    open={this.state.saveDialogOpen}
                    title={"確認"}
                    text={<span>入力内容を保存します。よろしいですか？</span>}
                    okFunction={this.handleSave}
                    closeFunction={this.handleCancelSave}
                />
                <Dialog
                    open={imageOpen}
                    onClose={this.handleImageClose}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        必要項目の見方
                    </DialogTitle>
                    <DialogContent>
                        <img src={"/images/upload-receipt/sample.jpg"} alt={"必要項目の見方"}/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleImageClose} color="primary">
                            閉じる
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

        );
    }
}
Viewer.propTypes = {
    filePath:PropTypes.string,
    dataSource:PropTypes.array,
    afterSaveFunc:PropTypes.func,
    afterCloseFunc:PropTypes.func
};
Viewer.defaultProps = {
    dataSource:[]
};
function mapStateToProps(state) {
    return {
        navigation : state.navigation
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(Viewer);


// WEBPACK FOOTER //
// ./src/routes/upload-receipt/components/viewer.js